import * as React from 'react';
import PropTypes from 'prop-types';
import NavItem from './NavItem';
import { User } from '../../models/User';

export interface NavItemLayoutProps {
    label: string;
    link: string;
}

type INavItemLayoutProps = {
    items: NavItemLayoutProps[];
    user: User;
    usersRoles: Record<string, any>[];
};

const NavItemLayout: React.FunctionComponent<INavItemLayoutProps> = (props) => {
    const allowed_users = ['darrius.alinsugay@globe.com.ph', 'jmreyes@globe.com.ph'];
    const get_reports_roles = () => {
        const usersWithReportsRole = props.usersRoles.filter((user): user is { user_email: string; roles: any[] } =>
            Array.isArray((user as any).roles),
        );
        const reports_email = usersWithReportsRole.map((user) => user.user_email);
        return reports_email;
    };

    return (
        <div className="w-full px-0 md:w-5/6 h-full">
            <ol className="w-full pr-16 h-auto flex flex-col md:h-full md:flex-row">
                {props.items.map((item, index) => {
                    // item.link === '/reports';
                    // if (
                    //     item.link === '/reports' &&
                    //     props.user.email !== null &&
                    //     // !allowed_users.includes(props.user.email)
                    //     !get_reports_roles().includes(props.user.email)
                    // ) {
                    //     return null;
                    // }

                    return <NavItem key={index} label={item.label} link={item.link} />;
                })}
            </ol>
        </div>
    );
};

NavItemLayout.propTypes = {
    items: PropTypes.array.isRequired,
};

export default NavItemLayout;
